import { useAuth } from "../authProvider";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  try {
    const currentUser = useAuth()?.currentUser;
    console.log("ProtectedRoute - currentUser:", currentUser);
    if (currentUser === null) {
      return <Navigate to={"/login"} />;
    } else return children;
  } catch (error) {
    console.error(error);
    return <Navigate to={"/login"} />;
  }
}

export default ProtectedRoute;
